import type { HTMLAttributes, ReactNode } from 'react'

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Resting cards use an inset-border technique, not a drop shadow
   * (components.md "Card"; tokens.md §7 `--border-inset-1`). `interactive`
   * adds the hover lift (`translateY(-2px)`, `--shadow-hover`, darkened
   * border — interactions.md §6) for cards that are themselves a click
   * target (e.g. a result card); non-interactive cards never move on
   * hover. */
  readonly interactive?: boolean
  readonly selected?: boolean
  readonly children: ReactNode
}

export function Card({
  interactive = false,
  selected = false,
  className,
  children,
  ...rest
}: CardProps) {
  const classes = [
    'card',
    interactive && 'card-interactive',
    selected && 'card-selected',
    className,
  ]
    .filter(Boolean)
    .join(' ')
  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  )
}
